export enum ModalMode {
    EDIT = 'edit',
    CREATE = 'create'
}
